import { TRACKER_IDS } from 'components/Trackers/trackerIDs'
import { Address, AddressDeliverabilityCorrectedAddress, UsStateCodes } from 'generated/types'

import { emptyAddress } from './constants'
import { ShippingFormattedAddress, ShippingSubRoutes } from './types'

export const formattedAddress = (
  address: Address | ShippingFormattedAddress,
): ShippingFormattedAddress => {
  if (address) {
    return {
      street1: address.street1,
      street2: address.street2 || '',
      city: address.city,
      zipCode: address.zipCode,
      state: address.state,
    }
  }
  return { ...emptyAddress }
}

export const pickAddress = (
  residential: ShippingFormattedAddress,
  mailing: ShippingFormattedAddress,
): ShippingFormattedAddress => {
  return formattedAddress(mailing.street1 !== '' ? mailing : residential)
}

export const formattedCorrectedAddress = (
  correctedAddress: AddressDeliverabilityCorrectedAddress,
): ShippingFormattedAddress => {
  return {
    street1: correctedAddress.street1 ?? '',
    street2: correctedAddress.street2 ?? '',
    city: correctedAddress.city ?? '',
    zipCode: correctedAddress.zipCode ?? '',
    state: correctedAddress.state ?? '',
  }
}

const stateList = Object.entries(UsStateCodes)
  .map(([label, value]) => ({
    label: label.toUpperCase(),
    value,
  }))
  .sort((a, b) => a.label.localeCompare(b.label))
export default stateList

export const getShippingSubrouteTrackingID = (subRoute: ShippingSubRoutes) => {
  switch (subRoute) {
    case ShippingSubRoutes.Preview:
      return TRACKER_IDS.SHIPPING_ADDRESS.BACK_BUTTON
    case ShippingSubRoutes.Edit:
      return TRACKER_IDS.SHIPPING_ADDRESS_EDIT.BACK_BUTTON
    case ShippingSubRoutes.Error:
      return TRACKER_IDS.SHIPPING_ADDRESS_NOT_FOUND.BACK_BUTTON
    case ShippingSubRoutes.Validation:
      return TRACKER_IDS.SHIPPING_ADDRESS_SUGGESTED.BACK_BUTTON
  }
}
